import { scoreLine } from '../utils/galiDisplay';
const INTERNAL_ID_PATTERN = /^(player:|temp:|saved:)?[a-f\d]{24}$/i;
const isInternalToken = (value) => typeof value === 'string' && (INTERNAL_ID_PATTERN.test(value.trim()) || ['teamA', 'teamB', 'team1', 'team2'].includes(value.trim()));
const safeSummaryText = (value) => (isInternalToken(value) ? 'Live score' : value);
const GaliScoreSummaryCard = ({ summary = {}, title = 'Score' }) => (
  <section className="gali-card gali-card-muted">
    <p className="text-uppercase small fw-bold text-muted mb-1">{title}</p>
    <h2 className="h4 mb-1">{scoreLine(summary)}</h2>
    <p className="mb-0 text-muted">{safeSummaryText(summary.result || summary.status || summary.message) || 'Backend score summary'}</p>
  </section>
);
export default GaliScoreSummaryCard;
